import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {AnalyticsModule} from 'app/analytics/analytics.module';
import {FeatureRequestModule} from 'app/user/feature-request/feature-request.module';
import {MixpanelNotificationsSource} from './mixpanel/mixpanel-notifications-source';
import {NotificationComponent} from './notification.component';
import {NotificationsComponent} from './notifications.component';
import {NotificationsService} from './notifications.service';
import {RequestTenantComponent} from './messages/request-tenant/request-tenant.component';
import {UIModule} from 'app/ui/ui.module';
import {NewlinePipe} from 'app/notifications/new-line.pipe';
import {PersonalizedLocalStorageService} from 'app/notifications/personalized-local-storage.service';

@NgModule({
    imports: [
        AnalyticsModule,
        CommonModule,
        FeatureRequestModule,
        UIModule
    ],
    providers: [
        NotificationsService,
        MixpanelNotificationsSource,
        PersonalizedLocalStorageService
    ],
    declarations: [
        NotificationComponent,
        NotificationsComponent,
        RequestTenantComponent,
        NewlinePipe
    ],
    exports: [NotificationsComponent]
})
export class NotificationsModule {
}